import React, { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import { getbaseinfo, deleteInfo, offShelveSoft } from "../../service/detail";
import { useNavigate } from "react-router-dom";
import ConfirmModal from "../../components/ConfirmModal";
import { useDispatch, useSelector } from "react-redux";
import clasnames from "classnames";
import Copy from "../../image/copy.svg";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { message } from "../../components/Message";
import { useHotkeys } from "react-hotkeys-hook";
import { editinfo } from "../../service/detail";
import styles from "./index.module.less";
import Editor from "../../image/editor.svg";
import { Divider, Input } from "antd";
import { useWorkspace } from "../../context/WorkspaceRegionProvider";
import { WORKSPACE_INTL } from "../../utils/workspace";
const { TextArea } = Input;
const Detail = () => {
  const { id } = useParams();
  const [result, setResult] = useState({});
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [copiedAppid, setCopiedAppid] = useState(false);
  const [copiedApp_secret, setApp_secret] = useState(false);

  // 编辑状态管理
  const [editable, setEditable] = useState(false);
  const [appEmailRefEditable, setAppEmailRefEditable] = useState(false); // 邮箱
  const [appPublicNameRefEditable, setAppPublicNameRefEditable] = useState(false); // QQ/微信/公众号
  const [appPhoneRefEditable, setAppPhoneRefEditable] = useState(false); // 联系电话
  const [appPublicPictureRefEditable, setAppPublicPictureRefEditable] = useState(false);
  const [appRemarkRefEditable, setAppRemarkRefEditable] = useState(false); // 备注

  // 输入框引用
  const inputRef = useRef(null);
  const appEmailRef = useRef(null); // 邮箱
  const appPublicNameRef = useRef(null); // QQ/微信/公众号
  const appPhoneRef = useRef(null); // 联系电话
  const appPublicPictureRef = useRef(null); // 公众号二维码
  const appRemarkRef = useRef(null); // 备注

  const [appRemarkValue, setAppRemarkValue] = useState("");


  const { config } = useSelector((state) => state);
  const navigate = useNavigate();
  const { setWorkspace, canUseIntl } = useWorkspace();
  const configType = config?.soft_cate?.find(
    (config) => config.id == result?.app_cate_d
  );
  const configSt = config?.app_status?.find(
    (config) => config.id == result?.app_status_id
  );
  console.log("configType is", configType);
  const focusInput = () => {
    // 收集所有编辑字段的最新值（优先取输入框值，无则取原有值）
    const callbackUrl = inputRef?.current?.value || result.callback_url || "";
    const appPhone = appPhoneRefEditable ? (appPhoneRef?.current?.value || "") : (result.app_phone || "");
    const appEmail = appEmailRefEditable ? (appEmailRef?.current?.value || "") : (result.app_email || "");
    const appPublicName = appPublicNameRefEditable ? (appPublicNameRef?.current?.value || "") : (result.app_public_name || "");
    const appPublicPicture = appPublicPictureRefEditable ? (appPublicPictureRef?.current?.value || "") : (result.app_public_picture || "");
    const appRemark = appRemarkRefEditable ? appRemarkValue.trim() : (result.remark || "");

    // 对于TextArea，需要使用不同的方式获取值
    // let appRemark = "";
    // if (appRemarkRefEditable && appRemarkRef?.current?.resizableTextArea?.textArea?.value !== undefined) {
    //   appRemark = appRemarkRef.current.resizableTextArea.textArea.value;
    // } else {
    //   appRemark = result.app_remark || "";
    // }

    if (callbackUrl || appPhone || appEmail || appPublicName || appPublicPicture || appRemark) {
      // 直接构建请求参数（无需通过params状态）
      const updateParams = {
        id: Number(id),
        app_id: result.app_id, // 固定字段
        callback_url: callbackUrl.trim(),
        app_phone: appPhone.trim(),
        app_email: appEmail.trim(),
        app_public_name: appPublicName.trim(),
        app_public_picture: appPublicPicture.trim(),
        remark: appRemark.trim(),

      };

      editinfo(updateParams).then(() => {
        getbaseinfo({ id }).then((res) => {
          console.log("res is", res);
          setResult(res);
        });
      });
      setEditable(false);
      setAppPhoneRefEditable(false);
      setAppPublicNameRefEditable(false);
      setAppEmailRefEditable(false);
      setAppPublicPictureRefEditable(false);
      setAppRemarkRefEditable(false);

    }
  };

  useHotkeys("enter", focusInput);

  useEffect(() => {
    getbaseinfo({ id }).then((res) => {
      console.log("res is", res);
      if (Number(res?.is_international) === 1) {
        if (canUseIntl) {
          setWorkspace(WORKSPACE_INTL);
          return;
        }
        message.show({
          type: "error",
          content: "该软件为国际版，请切换至国际工作台查看",
        });
        navigate("/view/home", { replace: true });
        return;
      }
      setResult(res);
      setAppRemarkValue(res.remark);
    });
  }, [id, canUseIntl, navigate, setWorkspace]);

  // 初始化加载详情数据
  useEffect(() => {
    editable && inputRef?.current?.focus();
  }, [editable]);

  /*
  useEffect(() => {
    document.addEventListener("click", focusInput);
    return () => {
      document.removeEventListener("click", focusInput);
    };
  }, [result]);
  */

  // 回调地址编辑状态 - 自动聚焦
  useEffect(() => {
    if (editable && inputRef?.current) {
      inputRef.current.focus();
    }
  }, [editable]);

  // 点击空白处保存编辑（所有字段通用）
  useEffect(() => {
    // 只有在任一编辑状态下才绑定事件
    const isEditing = editable;
    if (!isEditing) return;

    const handleClickOutside = () => {
      focusInput();
    };

    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [editable, focusInput]);


  // 下架处理
  const handleDelete = () => {
    offShelveSoft({
      id: Number(id),
      app_status_id: 5,
      app_id: result.app_id,
    }).then((res) => {
      navigate("/view/home");
    });
  };

  const editorClickFUnc = (e, num) => {

    e.stopPropagation();
    setEditable(false);
    setAppPhoneRefEditable(false);
    setAppPublicNameRefEditable(false);
    setAppEmailRefEditable(false);
    setAppPublicPictureRefEditable(false);
    setAppRemarkRefEditable(false);
    switch (num) {
      case 1: // 联系电话
        setAppPhoneRefEditable(true);
        break;
      case 2: // QQ/微信/公众号
        setAppPublicNameRefEditable(true);
        break;
      case 3: // 邮箱
        setAppEmailRefEditable(true);
        break;
      case 4: // 公众号二维码
        setAppPublicPictureRefEditable(true);
        break;
      case 5: // 备注
        setAppRemarkRefEditable(true);
        break;
      default:
        setEditable(true); // 默认编辑回调地址
    }
  }

  const handleRemarkChange = (e) => {
    setAppRemarkValue(e.target.value);
  };

  return (
    <div className={styles.detail}>
      <div onClick={() => navigate(-1)} className={styles.back}>
        {" "}
        {`<返回`}
      </div>
      <div className={styles.detailwrapper}>
        <div className={styles.detailTop}>
          <div
            className={styles.logo}
            style={{
              backgroundImage: `url(${result?.logo_url
                ? result?.logo_url
                : "https://p3.ssl.qhimg.com/t01ea0f774a67ee6d1a.png"
                })`,
            }}
          ></div>
          <div className={styles.cpname}>{result?.app_name}</div>
        </div>
        <div className={styles.detailContent}>
          <div className={styles.detailItem}>
            <div className={styles.itemName}>更新时间：</div>
            <div className={styles.itemVal}>{result.mtime}</div>
          </div>
          <div className={styles.detailItem}>
            <div className={styles.itemName}>AppID：</div>
            <div className={styles.itemVal}>
              <CopyToClipboard
                onCopy={() => {
                  message.show({
                    type: "success",
                    content: "复制成功！",
                  });
                  setCopiedAppid(true);
                }}
                text={result.app_id}
              >
                <div>
                  <span className={styles.copytext}>{result.app_id}</span>
                  <Copy className={clasnames(styles.copy)}></Copy>
                </div>
              </CopyToClipboard>
            </div>
          </div>
          <div className={styles.detailItem}>
            <div className={styles.itemName}>软件类型：</div>
            <div className={styles.itemVal}>
              {configType?.name ? configType?.name : "--------"}{" "}
            </div>
          </div>
          <div className={styles.detailItem}>
            <div className={styles.itemName}>AppSecret：</div>
            <div className={styles.itemVal}>
              {result.app_secret ? (
                <CopyToClipboard
                  onCopy={() => {
                    message.show({
                      type: "success",
                      content: "复制成功！",
                    });
                    setApp_secret(true);
                  }}
                  text={result.app_secret}
                >
                  <div>
                    <span className={styles.copytext}>{result.app_secret}</span>
                    <Copy className={clasnames(styles.copy)}></Copy>
                  </div>
                </CopyToClipboard>
              ) : null}
            </div>
          </div>
          <div className={styles.detailItem}>
            <div className={styles.itemName}>软件版本：</div>
            <div className={styles.itemVal}>
              {result.app_version ? result.app_version : "--------"}
            </div>
          </div>
          <div className={styles.detailItem}>
            <div className={styles.itemName}>回调地址：</div>
            <div
              // onEnter
              // onDoubleClick={() => {
              //   setEditable(true);
              // }}
              onClick={(e) => e.stopPropagation()}
              className={styles.itemVal}
            >
              {editable ? (
                <>
                  <input
                    ref={inputRef}
                    defaultValue={result.callback_url}
                    // onKeyUp={(event) => event.key === "Enter" && focusInput()}
                    className={styles.editInput}
                  ></input>
                </>
              ) : (
                <>
                  <span>
                    {result.callback_url ? result.callback_url : "------"}
                  </span>
                  <Editor
                    onClick={(e) => {
                      e.stopPropagation();
                      setEditable(true);
                    }}
                    className={styles.editor}
                  ></Editor>
                </>
              )}
            </div>
          </div>
          <div className={styles.detailItem}>
            <div className={styles.itemName}>软件状态：</div>
            <div className={styles.itemVal}>
              {result.app_status_id ? configSt?.name : "--------"}
            </div>
          </div>
          <div className={styles.detailItem}>
            <div className={styles.itemName}> </div>
            <div className={styles.itemVal}> </div>
          </div>
          <div className={styles.detailItem}>
            <div className={styles.itemName}>软件环境：</div>
            <div className={styles.itemVal}>
              {result.channel == 0 ? "测试" : "正式"}
            </div>
          </div>
        </div>

        <div className={styles.detailContent}>
          <Divider >用户将会通过以下方式联系您</Divider>
          <div className={styles.detailItem}>
            <div className={styles.itemName}>联系电话：</div>
            <div className={styles.itemVal}>
              {/* {result.app_phone} */}
              {appPhoneRefEditable ? (
                <>
                  <input onBlur={focusInput}
                    ref={appPhoneRef}
                    defaultValue={result.app_phone || ""}
                    className={styles.editInput}
                  ></input>
                </>
              ) : (
                <>
                  <span>{result.app_phone ? result.app_phone : "------"}</span>
                  <Editor onClick={(e) => { editorClickFUnc(e, 1) }} className={styles.editor}></Editor>
                </>
              )}
            </div>
          </div>

          <div className={styles.detailItem}>
            <div className={styles.itemName}>QQ\微信\公众号：</div>
            <div className={styles.itemVal}>
              {/* {result.app_public_name} */}
              {appPublicNameRefEditable ? (
                <>
                  <input onBlur={focusInput}
                    ref={appPublicNameRef}
                    defaultValue={result.app_public_name || ""}
                    className={styles.editInput}
                  ></input>
                </>
              ) : (
                <>
                  <span>{result.app_public_name ? result.app_public_name : "------"}</span>
                  <Editor onClick={(e) => { editorClickFUnc(e, 2) }} className={styles.editor}></Editor>
                </>
              )}
            </div>
          </div>

          <div className={styles.detailItem}>
            <div className={styles.itemName}>邮箱：</div>
            <div className={styles.itemVal}>
              {/* {result.app_email} */}
              {appEmailRefEditable ? (
                <>
                  <input onBlur={focusInput}
                    ref={appEmailRef}
                    defaultValue={result.app_email || ""}
                    className={styles.editInput}
                  ></input>
                </>
              ) : (
                <>
                  <span>{result.app_email ? result.app_email : "------"}</span>
                  <Editor onClick={(e) => { editorClickFUnc(e, 3) }} className={styles.editor}></Editor>
                </>
              )}
            </div>
          </div>

          <div className={styles.detailItem}>
            <div className={styles.itemName}>公众号二维码：</div>
            {/* <img className={styles.itemVal} src={result.app_public_picture} /> */}
            <div className={styles.itemVal}>
              {/* {result.app_email} */}
              {appPublicPictureRefEditable ? (
                <>
                  <input onBlur={focusInput}
                    ref={appPublicPictureRef}
                    defaultValue={result.app_public_picture || ""}
                    className={styles.editInput}
                  ></input>
                </>
              ) : (
                <>
                  <span>{result.app_public_picture ? result.app_public_picture : "------"}</span>
                  <Editor onClick={(e) => { editorClickFUnc(e, 4) }} className={styles.editor}></Editor>
                </>
              )}
            </div>
          </div>
        </div>

        <div className={styles.detailContent}>
          <div className={styles.detailItem}>
            <div className={styles.itemName}>备注：</div>
            <TextArea value={appRemarkValue} onChange={handleRemarkChange} onBlur={focusInput} ref={appRemarkRef} disabled={!appRemarkRefEditable} className={styles.textAreaStyle} rows={4} maxLength={100} showCount />
            <Editor onClick={(e) => { editorClickFUnc(e, 5) }} className={styles.editor}></Editor>

          </div>
        </div>

        <div className={styles.deleteGroup}>
          <div onClick={() => {
            if (result.channel == 0 || result.app_status_id != 4) {
              return;
            }
            setConfirmOpen(true);
          }}
            className={clasnames(styles.delete, {
              [styles.disabled]: result.app_status_id != 4,
            })}
          >
            {result.app_status_id == 1 ? "未上架" : "去下架"}
          </div>
          <div onClick={() => {
              if (result.channel == 0 || result.app_status_id == 2) {
                return;
              }
              navigate(`/view/register/${id}`);
            }}
            className={clasnames(styles.onShelves, {
              [styles.disabled]:
                result.app_status_id == 2 || result.channel == 0,
            })}
          >
            {result.app_status_id == 1 ? "去上架" : "去更新"}
          </div>
        </div>
      </div>
      <ConfirmModal
        title={result?.app_name}
        onOk={handleDelete}
        onClose={() => setConfirmOpen(false)}
        open={confirmOpen}
      ></ConfirmModal>
    </div>
  );
};

export default Detail;
